module.exports = __webpack_public_path__ + "img/payment03.075a6e93.png";